module.exports = __webpack_public_path__ + "img/icon-time.b0b10b89.svg";